import type { ThemeConfig } from 'antd';
import localFont from 'next/font/local';

import { DEFAULT_LOCALE } from '~/universal/constants';

export const filesFormat = {
  'image/jpeg': [],
  'image/jpg': [],
  'image/png': [],
  'image/gif': [],
  'image/webp': [],
  'application/vnd.ms-excel': [],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [],
  'text/csv': [],
  'application/pdf': [],
  'text/plain': [],
  'application/msword': [],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [],
  'application/vnd.ms-powerpoint': [],
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': [],
};

// Font files can be colocated inside of `pages`
const font = localFont({
  src: '../../assets/fonts/Montserrat-VariableFont_wght.ttf',
});

const isLocal = process.env.SERVER_ENV === 'local';
const isProduction = process.env.NODE_ENV === 'production';

export const appSettings = {
  app: {
    title: 'Prana Club',
  },
  port: isProduction && !isLocal ? '' : 3000,
  host: isProduction && !isLocal ? 'https://prana-club.com' : 'http://localhost',
};

export const settings = {
  theme: {
    zeroRuntime: true,
    components: {
      Table: {
        stickyScrollBarBg: 'rgba(0,0,0,0.28)',
        stickyScrollBarBorderRadius: 100,
        rowSelectedBg: '#ccc',
        rowHoverBg: '#ccc',
        rowSelectedHoverBg: '#ccc',
      },
    },
    token: {
      colorPrimary: '#feda2f',
      colorLink: '#feda2f',
      colorBgLayout: '#ffffff',
      fontFamily: font.style.fontFamily,
      fontWeight: 400,
      fontSize: 12,
    },
  } as ThemeConfig,
  language: DEFAULT_LOCALE,
  app: {
    htmlAttributes: {
      lang: DEFAULT_LOCALE,
    },
    title: 'Prana Club',
    paginationLength: 2,
    mainContainerWidth: { xs: '94%', sm: '94%', md: '900px' },
    titleTemplate: 'Prana Club - %s',
    meta: [
      {
        name: 'description',
        content: process.env.NODE_ENV === 'production' ? 'Prana Club описание.' : 'Prana Club description.',
      },
    ],
  },
};
